import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Row } from "../../components/Component";
import TotalSales from "../../components/partials/e-commerce/total-sales/TotalSales";
import Orders from "../../components/partials/e-commerce/orders/Orders";
import Customer from "../../components/partials/e-commerce/customers/Customer";
import StoreStatistics from "../../components/partials/default/StoreStatistics";
import RecentOrders from "../../components/partials/default/recent-orders/RecentOrders";
import TopProducts from "../../components/partials/default/top-products/TopProducts";
import { useLocation, useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import { getDashboardAPI, getDashboardPopularProductsAPI } from "../../api/dashboard/admin";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import { getDashboardOrdersAPI, getOrdersDetailsAPI } from "../../api/order";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(4);
  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      topProductLoading: true,
      tableLoading: true,
      orderData: [],
      salesData: [],
      orders: [],
      customerData: [],
      storeStats: [],
      topProducts: [],
      limit: 4,

      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [onSearch, setonSearch] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const [filter, setFilter] = useState("Weekly");
  const isLoading = watch("isLoading");
  const tableLoading = watch("tableLoading");
  const topProductLoading = watch("topProductLoading");
  const orderData = watch("orderData");
  const salesData = watch("salesData");
  const storeStats = watch("storeStats");
  const orders = watch("orders");
  const limit = watch("limit");
  const customerData = watch("customerData");
  const topProducts = watch("topProducts");
  useEffect(() => {
    getDashboardData();
  }, []);
  const getDashboardData = () => {
    setValue("isLoading", true);
    getDashboardAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("salesData", res?.data?.data?.totalSales);
          setValue("orders", res?.data?.data?.orderData);
          setValue("customerData", res?.data?.data?.customerData);
          setValue("storeStats", res?.data?.data?.storeStats);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("cityDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getOrders = (body) => {
    getDashboardOrdersAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("limit", res.data.data?.totalPages);
          setValue("orderData", res.data.data);
          setValue("tableLoading", false);
        } else if (res.data.status === false) {
          setValue("tableLoading", false);
          setValue("cityDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("tableLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("tableLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(onSearchText);
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [onSearchText]);
  useEffect(() => {
    const body = {
      search: debouncedSearch,
      page: currentPage,
      limit: itemPerPage,
    };

    getOrders(body);
  }, [debouncedSearch, currentPage, itemPerPage]);
  const getPopularProduct = (body) => {
    getDashboardPopularProductsAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("topProducts", res.data.data);
          setValue("topProductLoading", false);
        } else if (res.data.status === false) {
          setValue("topProductLoading", false);
          setValue("cityDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("topProductLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("topProductLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const body = {
      filter: filter,
    };
    getPopularProduct(body);
  }, [filter]);
  const onOrderClick = (item) => {
    const body = {
      order_id: item?.orderNum,
    };
    navigate("/order-details", { state: body });
  };
  return (
    <>
      <Head title={"Dashboard"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Dashboard</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={"g-gs"}>
            <Col xxl={4} md={6}>
              <TotalSales data={salesData} isLoading={isLoading} />
            </Col>{" "}
            <Col xxl="4" md="6">
              <StoreStatistics data={storeStats} isLoading={isLoading} />
            </Col>
            <Col xxl="4">
              <Row className="g-gs">
                <Col xxl="12" md="6">
                  <Orders data={orders} isLoading={isLoading} />
                </Col>
                <Col xxl="12" md="6">
                  <Customer data={customerData} isLoading={isLoading} />
                </Col>
              </Row>
            </Col>
            <Col xxl="8">
              <RecentOrders
              title={"Recent Orders"}
                setSearchText={setSearchText}
                onSearchText={onSearchText}
                onSearch={onSearch}
                setonSearch={setonSearch}
                data={orderData?.orders}
                limit={limit}
                setItemPerPage={setItemPerPage}
                itemPerPage={itemPerPage}
                paginate={paginate}
                currentPage={currentPage}
                isLoading={tableLoading}
                onOrderClick={onOrderClick}
              />
            </Col>
            <Col xxl="4" md="6">
              <TopProducts data={topProducts} filter={filter} setFilter={setFilter} isLoading={topProductLoading} />
            </Col>
          </Row>
        </Block>
      </Content>
    </>
  );
};

export default AdminDashboard;
